"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteEvaluateLabel = deleteEvaluateLabel;
exports.getEvaluateLabelByType = getEvaluateLabelByType;
exports.getEvaluateLabelInfo = getEvaluateLabelInfo;
exports.getEvaluateLabelList = getEvaluateLabelList;
exports.saveEvaluateLabel = saveEvaluateLabel;
exports.updateEvaluateLabel = updateEvaluateLabel;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 查询所有启用的标签列表
 */
function getEvaluateLabelList() {
  return (0, _requestAuth.default)({
    url: '/xyEvaluateLabel/list',
    method: 'get'
  });
}

/**
 * 根据标签类型查询启用的标签列表
 * @param {Number} labelType 标签类型: 1-好评标签 2-差评标签
 */
function getEvaluateLabelByType(labelType) {
  return (0, _requestAuth.default)({
    url: "/xyEvaluateLabel/listByType/".concat(labelType),
    method: 'get'
  });
}

/**
 * 查询单个标签详情
 * @param {Number} id 标签ID
 */
function getEvaluateLabelInfo(id) {
  return (0, _requestAuth.default)({
    url: "/xyEvaluateLabel/".concat(id),
    method: 'get'
  });
}

/**
 * 保存标签
 * @param {Object} data 标签数据
 */
function saveEvaluateLabel(data) {
  return (0, _requestAuth.default)({
    url: '/xyEvaluateLabel',
    method: 'post',
    data: data
  });
}

/**
 * 修改标签
 * @param {Object} data 标签数据
 */
function updateEvaluateLabel(data) {
  return (0, _requestAuth.default)({
    url: '/xyEvaluateLabel',
    method: 'put',
    data: data
  });
}

/**
 * 删除标签
 * @param {Number} id 标签ID
 */
function deleteEvaluateLabel(id) {
  return (0, _requestAuth.default)({
    url: '/xyEvaluateLabel',
    method: 'delete',
    params: {
      id: id
    }
  });
}